import { useState, useEffect } from 'react';

function useScreenSize() {
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [logoClass, setLogoClass] = useState('hidden');

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 640);
      setLogoClass(isSmallScreen ? 'hidden' : '');
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isSmallScreen]);

  return { isSmallScreen, logoClass };
}

export default useScreenSize;
